// Mirrors the crawler's RedirectChain.isRedirectLoop: a loop is a redirect
// (3xx) element whose destination is a URI already visited by the chain —
// including itself. The crawler aborts the crawl at that element, so a
// persisted loop chain ends in that 3xx (never a 200) alongside
// crawlStatus "Unable to crawl: ERROR: Redirect Loop". A healthy chain's
// terminal hop is a self-referential 200 element (source == destination),
// which this deliberately does not match.
export function isRedirectLoop(elements) {
    if (!Array.isArray(elements)) return false;
    const visited = new Set();
    for (const el of elements) {
        if (el?.sourceURI) visited.add(el.sourceURI);
        const status = parseInt(el?.httpStatus, 10);
        if (status >= 300 && status < 400 && el.destinationURI && visited.has(el.destinationURI)) return true;
    }
    return false;
}

// Where the chain ended up: the last element's status. 200 for a healthy
// landing, 3xx when the crawl aborted mid-redirect (loop or other error),
// 4xx/5xx when it landed on an error page. null when there is no chain.
export function finalHttpStatus(elements) {
    if (!Array.isArray(elements) || elements.length === 0) return null;
    const status = parseInt(elements[elements.length - 1]?.httpStatus, 10);
    return Number.isNaN(status) ? null : status;
}
